export const getTenantHostName = async () => {
  // if (!window.browser) {
  // 	return;
  // }
  // if (window.ENV.NEXT_PUBLIC_NODE_ENV === "development") {
  // 	return;
  // }
  let response;
  let tId = window.location.hostname.split(".")[0].replace("127", "alpha");
  tId = tId.replace("-cdev", "");

  if (tId === "consignment-tracking" || tId === "dynamic-discussion") {
    tId = "alpha";
  }

  // tId = "alpha";

  try {
    // window.ENV.ORGANISATION_NAME = tId;
    response = await $.ajax({
      url: `https://developerplatform.preprod.dlv2.fxtrt.io/app/core-api/tenant?orgShortName=${tId}`,
      method: "GET",
    });
  } catch (err) {
    console.error(err);
  }

  return response?.data;
};
